import { LocalStorage } from '@/core/Storage';
type Userpilot = {
  initialize(str: string, settings?: Object): void;
  clearQueue(): void;
  reload(url?: any): void;
  identify(userid: string, pramaters?: Object): void;
  suppress(options?: Object): void;
  unsuppress(options?: Object): void;
  trigger(token: string): void;
  anonymous(data?: Object): void;
  on(event: string, cb: any): void;
  once(event: string, cb: any): void;
  off(event: string): void;
  track(event: string, meta?: Object): void;
  reset(): void;
  next(): void;
  end(type?: string): void;
  clean(): void;
  destroy(): void;
  theme(title: string): void;
};

export class UserPilot {
  static initialize(str: string, settings?: Object): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.initialize === 'function') {
      window.userpilot?.initialize(str, settings);
    }
  }

  static clearQueue(): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.clearQueue === 'function') {
      window.userpilot?.clearQueue();
    }
  }

  static reload(url?: any): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.reload === 'function') {
      window.userpilot?.reload(url || window.location.pathname);
    }
  }

  static identify(userid: string, pramaters?: Object): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.identify === 'function') {
      if (LocalStorage.getItem('superuser')) {
        return window.userpilot?.identify('service_user_id', { ...(pramaters || {}), email: 'service_user@toughcommerce.com' });
      }
      window.userpilot?.identify(userid, pramaters);
      UserPilot.reload();
    }
  }

  static suppress(options?: Object): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.suppress === 'function') {
      window.userpilot?.suppress(options);
    }
  }

  static unsuppress(options?: Object): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.unsuppress === 'function') {
      window.userpilot?.unsuppress(options);
    }
  }

  static trigger(token: string): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.trigger === 'function') {
      window.userpilot?.trigger(token);
    }
  }

  static anonymous(data?: Object): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.anonymous === 'function') {
      window.userpilot?.anonymous(data);
      UserPilot.reload();
    }
  }

  static on(event: string, cb: any): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.on === 'function') {
      window.userpilot?.on(event, cb);
    }
  }

  static once(event: string, cb: any): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.once === 'function') {
      window.userpilot?.once(event, cb);
    }
  }

  static off(event: string): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.off === 'function') {
      window.userpilot?.off(event);
    }
  }

  static track(event: string, meta?: Object): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.track === 'function') {
      window.userpilot?.track(event, meta);
    }
  }

  static reset(): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.reset === 'function') {
      window.userpilot?.reset();
    }
  }

  static next(): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.next === 'function') {
      window.userpilot?.next();
    }
  }

  static end(type?: string): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.end === 'function') {
      window.userpilot?.end(type);
    }
  }

  static clean(): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.clean === 'function') {
      window.userpilot?.clean();
    }
  }

  static destroy(): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.destroy === 'function') {
      window.userpilot?.destroy();
    }
  }

  static theme(title: string): void {
    if (process.env.REACT_APP_USER_PILOT && typeof window.userpilot?.theme === 'function') {
      window.userpilot?.theme(title);
    }
  }
}

declare global {
  interface Window {
    userpilot?: Userpilot;
  }
}
